import React, { Component } from 'react';

import GlobalStoreContext from '../context/GlobalStoreContext';









export default class GlobalStoreProvider extends
Component {
  constructor(props) {
    super(props);

    this.state = {
      keyStateMap: new Map()
    };
  }

  setObjectForKey = (key, state) => {
    const { keyStateMap } = this.state;

    keyStateMap.set(key, {
      ...state,
      _stateTimeStamp: Date.now()
    });
  };

  updateObjectForKey = (key, state) => {
    const { keyStateMap } = this.state;

    const prevObjectForKey = keyStateMap.get(key) || {};

    keyStateMap.set(key, {
      ...prevObjectForKey,
      ...state,
      _stateTimeStamp: Date.now()
    });
  };

  getObjectForKey = (key) => {
    const { keyStateMap } = this.state;

    return keyStateMap.get(key) || {};
  };

  render() {
    const { children } = this.props;

    const getProviderValue = {
      setObjectForKey: this.setObjectForKey,
      updateObjectForKey: this.updateObjectForKey,
      getObjectForKey: this.getObjectForKey
    };

    return (
      <GlobalStoreContext.Provider value={getProviderValue}>
        {children}
      </GlobalStoreContext.Provider>);

  }
}